var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.91,37.62c0.03-0.55-0.14-1.1-0.56-1.52L59.08,24.83c-0.43-0.43-1.01-0.6-1.57-0.55H32.85    c-2.11,0-3.81,1.71-3.81,3.81v43.83c0,2.1,1.71,3.81,3.81,3.81h34.3c2.1,0,3.81-1.71,3.81-3.81v-34.3H70.91z M57.62,29l8.62,8.62    h-8.62V29z M67.15,71.92h-34.3V28.09h20.96v11.43c0,1.05,0.85,1.91,1.91,1.91h11.43V71.92z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/Icon_document.7dd04c9dccd04acbf6423bf9523ca5fd.svg";
export { ForwardRef as ReactComponent };